import { cn } from "@/modules/lib/utils"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { UserProgramDetailsEntity } from "@modules/programs/entities/userProgramDetailsEntity"
import { ProgramSubscriberDetailsContent } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContent"
import { ProgramSubscriberDiscountForm } from "@modules/programs/programSubscriber/components/programSubscriberDiscountForm"
import { ProgramSubscriberInternalNoteForm } from "@modules/programs/programSubscriber/components/programSubscriberInternalNoteForm"
import { ProgramSubscriberPauseForm } from "@modules/programs/programSubscriber/components/programSubscriberPauseForm"
import { ProgramSubscriberDetailsViewTabs } from "@modules/programs/programSubscriber/entities/programSubsciberType"
import {
  useProgramSubscriberDetails,
  UseProgramSubscriberDetailsKey,
} from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"
import { useState } from "react"

type ProgramSubscriberDetailsWrapperProps = {
  program: UserProgramDetailsEntity | ProgramBundleEntity
  subscriberId: string
  isBoxSubscriber: boolean
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsWrapper({
  program,
  subscriberId,
  isBoxSubscriber,
  className,
  ...props
}: ProgramSubscriberDetailsWrapperProps) {
  const [activeTab, setActiveTab] = useState<ProgramSubscriberDetailsViewTabs>(ProgramSubscriberDetailsViewTabs.DETAILS)
  const { data: subscriberDetails } = useProgramSubscriberDetails(
    program instanceof ProgramBundleEntity
      ? UseProgramSubscriberDetailsKey.PROGRAM_BUNDLE_SUBSCRIBER
      : isBoxSubscriber
        ? UseProgramSubscriberDetailsKey.PROGRAM_BOX_SUBSCRIBER
        : UseProgramSubscriberDetailsKey.PROGRAM_SUBSCRIBER,
    program.id,
    subscriberId,
  )

  return (
    <div className={cn("flex w-full grow flex-col p-5", className)} {...props}>
      {/* CONTENT */}
      {activeTab === ProgramSubscriberDetailsViewTabs.INTERNAL_NOTE_FORM ? (
        <ProgramSubscriberInternalNoteForm
          subscriberDetails={subscriberDetails}
          moveToSubscriberDetails={() => setActiveTab(ProgramSubscriberDetailsViewTabs.DETAILS)}
          programId={program.id}
        />
      ) : activeTab === ProgramSubscriberDetailsViewTabs.PAUSE_FORM ? (
        <ProgramSubscriberPauseForm
          subscriberDetails={subscriberDetails}
          moveToSubscriberDetails={() => setActiveTab(ProgramSubscriberDetailsViewTabs.DETAILS)}
          programId={program.id}
        />
      ) : activeTab === ProgramSubscriberDetailsViewTabs.DISCOUNT_FORM ? (
        <ProgramSubscriberDiscountForm
          subscriberDetails={subscriberDetails}
          moveToSubscriberDetails={() => setActiveTab(ProgramSubscriberDetailsViewTabs.DETAILS)}
          programId={program.id}
        />
      ) : (
        <ProgramSubscriberDetailsContent
          subscriberDetails={subscriberDetails}
          setActiveTab={setActiveTab}
          programId={program.id}
        />
      )}
    </div>
  )
}
